export interface ScrollContainerClaim<T> {
  token: symbol;
  container: T;
  priority: number;
  order: number;
}

export const selectActiveScrollContainer = <T>(
  claims: readonly ScrollContainerClaim<T>[],
): T | null => {
  let winner: ScrollContainerClaim<T> | null = null;

  for (const claim of claims) {
    if (
      !winner
      || claim.priority > winner.priority
      || (claim.priority === winner.priority && claim.order > winner.order)
    ) {
      winner = claim;
    }
  }

  return winner?.container ?? null;
};
